var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container bairun-station-check-update" },
    [
      _c(
        "div",
        [
          _c("span", { staticClass: "divider-title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _c("el-divider")
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: "24" } },
            [
              _c(
                "el-form",
                {
                  staticClass: "add-form",
                  attrs: { model: _vm.formData, "label-position": "right" }
                },
                [
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "油站：" }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "选择油站", disabled: "" },
                              model: {
                                value: _vm.formData.stationId,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "stationId", $$v)
                                },
                                expression: "formData.stationId"
                              }
                            },
                            _vm._l(_vm.asyncStations, function(item) {
                              return _c("el-option", {
                                key: item.ID,
                                attrs: {
                                  label: item.stationName,
                                  value: item.ID
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "bairun-required",
                          attrs: { label: "所属期：" }
                        },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyyMMdd",
                              placeholder: "日期选择",
                              clearable: false,
                              disabled: ""
                            },
                            model: {
                              value: _vm.formData.dailyDate,
                              callback: function($$v) {
                                _vm.$set(_vm.formData, "dailyDate", $$v)
                              },
                              expression: "formData.dailyDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.formData.rows,
                                stripe: "",
                                border: ""
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: { label: "油罐" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("div", [
                                          _vm._v(
                                            _vm._s(scope.row.tankNum) +
                                              "号灌-#" +
                                              _vm._s(scope.row.oilCode)
                                          )
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c("el-table-column", {
                                attrs: { label: "调灌(升)" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _c("el-input-number", {
                                          attrs: {
                                            clearable: "",
                                            placeholder: "请输入",
                                            controls: false
                                          },
                                          model: {
                                            value: scope.row.tankAdjustLiters,
                                            callback: function($$v) {
                                              _vm.$set(
                                                scope.row,
                                                "tankAdjustLiters",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "scope.row.tankAdjustLiters"
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ])
                              }),
                              _c(
                                "el-table-column",
                                {
                                  attrs: {
                                    label: "液位仪计量",
                                    "header-align": "center"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { label: "油高(mm)" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-input-number", {
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入",
                                                min: 0,
                                                controls: false
                                              },
                                              model: {
                                                value:
                                                  scope.row.sequenceOilHeight,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "sequenceOilHeight",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.sequenceOilHeight"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "水高(mm)" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-input-number", {
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入",
                                                min: 0,
                                                controls: false
                                              },
                                              model: {
                                                value:
                                                  scope.row.sequenceWaterHeight,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "sequenceWaterHeight",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.sequenceWaterHeight"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "水体积(mm)" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-input-number", {
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入",
                                                min: 0,
                                                controls: false
                                              },
                                              model: {
                                                value:
                                                  scope.row
                                                    .sequenceWaterCapacity,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "sequenceWaterCapacity",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.sequenceWaterCapacity"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "油液位体积(升)" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-input-number", {
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入",
                                                min: 0,
                                                controls: false
                                              },
                                              model: {
                                                value:
                                                  scope.row.sequenceOilCapacity,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "sequenceOilCapacity",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.sequenceOilCapacity"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-table-column",
                                {
                                  attrs: {
                                    label: "手工计量",
                                    "header-align": "center"
                                  }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { label: "油高(mm)" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-input-number", {
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入",
                                                min: 0,
                                                controls: false
                                              },
                                              model: {
                                                value:
                                                  scope.row.measureOilHeight,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "measureOilHeight",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.measureOilHeight"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "水高(mm)" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-input-number", {
                                              attrs: {
                                                clearable: "",
                                                placeholder: "请输入",
                                                min: 0,
                                                controls: false
                                              },
                                              model: {
                                                value:
                                                  scope.row.measureWaterHeight,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "measureWaterHeight",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.measureWaterHeight"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "水体积(mm)" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-input-number", {
                                              attrs: {
                                                clearable: "",
                                                placeholder:
                                                  scope.row.tankHeightStatus ===
                                                  1
                                                    ? "系统自动计算"
                                                    : "请输入",
                                                min: 0,
                                                controls: false,
                                                disabled:
                                                  scope.row.tankHeightStatus ===
                                                  1
                                              },
                                              model: {
                                                value:
                                                  scope.row
                                                    .measureWaterCapacity,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "measureWaterCapacity",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.measureWaterCapacity"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "油实际体积(升)" },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "default",
                                        fn: function(scope) {
                                          return [
                                            _c("el-input-number", {
                                              attrs: {
                                                clearable: "",
                                                placeholder:
                                                  scope.row.tankHeightStatus ===
                                                  1
                                                    ? "系统自动计算"
                                                    : "请输入",
                                                min: 0,
                                                controls: false,
                                                disabled:
                                                  scope.row.tankHeightStatus ===
                                                  1
                                              },
                                              model: {
                                                value:
                                                  scope.row.measureOilCapacity,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    scope.row,
                                                    "measureOilCapacity",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "scope.row.measureOilCapacity"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ])
                                  })
                                ],
                                1
                              ),
                              _c(
                                "el-table-column",
                                {
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: { type: "danger" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onDelRow(
                                                    scope.$index
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("删除")]
                                          )
                                        ]
                                      }
                                    }
                                  ])
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "header" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: { type: "primary" },
                                          on: { click: _vm.onAddRow }
                                        },
                                        [_vm._v("新增")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bairun-bottom-tool" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function() {
                  _vm.goBack()
                }
              }
            },
            [_vm._v("返回")]
          ),
          _c("el-button", { on: { click: _vm.onClear } }, [_vm._v("清空")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("提交")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }